import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Section-Divider" }
const _hoisted_2 = { class: "App-Div-Icon" }
const _hoisted_3 = { class: "App-Div-Action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_divider, { "content-position": "left" }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.content), 1),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "action")
        ])
      ]),
      _: 3
    })
  ]))
}